/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// React
import React, { forwardRef, useEffect } from "react";
// form library
import { Controller, useFormContext } from 'react-hook-form';
// custom components
import ElementsArray from "../508-table/ElementsArray";
import LeadNumberedHeading from "../../../../shared-components/forms/LeadNumberedHeading";
import NumberedHeading from "../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from '../../../../shared-components/WYSIWYGEditor';

const defaultValues = [
  {
    element: "",
    items: [
      { 
        compliance: "",
        notes: "",
      }
    ]
  },
];

function AccessibilityForm(props) {
  const methods = useFormContext();
  const { control, formState, register } = methods;
  const { errors } = formState;

  return (
    <>
      <LeadNumberedHeading number="4" title="508 Compliance Plan" instructions="This information is used to store the accessibility requiremnets for the template." />

      <div className="flex flex-col w-full">
        <NumberedHeading number="1" title="Accessibility Brief" instructions="Enter a branching information for the template." />
        <Controller
          render={({ field }) => <WYSIWYGEditor {...field} error={errors.accessibility} />}
          name="accessibility"
          control={control}
        />

        <NumberedHeading number="2" title="Compliance Outline" instructions="Enter a specific compliance information for the template's components." />
        <Controller
          control={control}
          name="access_table"
          render={({ field }) => <ElementsArray {...{ control, register, defaultValues, errors }} />}
        />
      </div>
    </>
  );
};

export default AccessibilityForm;